export function getLoginErrorMessage(err: any): string {
  const status = err?.response?.status
  const message = typeof err?.message === 'string' ? err.message : ''
  if (status === 401 || status === 403) return 'Feil e-post eller passord.'
  if (status === 429) {
    const retryAfter = Number(err?.response?.headers?.['retry-after'])
    if (Number.isFinite(retryAfter) && retryAfter > 0) {
      const minutes = Math.ceil(retryAfter / 60)
      return `For mange innloggingsforsøk. Prøv igjen om ca. ${minutes} ${minutes === 1 ? 'minutt' : 'minutter'}.`
    }
    return 'For mange innloggingsforsøk. Prøv igjen om litt.'
  }
  if (err?.code === 'ECONNABORTED' || message.toLowerCase().includes('timeout')) {
    return 'Innlogging tok for lang tid. Prøv igjen.'
  }
  if (!err?.response || err?.message === 'Network Error') {
    return 'Får ikke kontakt med innloggingstjenesten. Sjekk at backend kjører, eller prøv igjen.'
  }
  return 'Innlogging feilet. Prøv igjen.'
}
